import {
  Container,
  Box,
  Typography,
  Button,
  useMediaQuery,
  useTheme,
  Stack,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { CheckCircleOutline } from "@mui/icons-material";

export interface ConfirmationProps {
  onBack: () => void;
  onNext: () => void;
}

const Confirmation: React.FC<ConfirmationProps> = ({ onBack, onNext }) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { businessName } = useParams();
  return (
    <Container
      sx={{
        width: "100%",
        maxWidth: "100%",
        height: isMobile ? "93vh" : "80vh",
        boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
        padding: isMobile ? "20px" : "20px",
        background: "#f2f0f0",
        margin: "0 auto",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 2,
        }}
      >
        <CheckCircleOutline
          sx={{
            fontSize: 80,
            color: theme.palette.success.main,
            mb: 2,
          }}
        />

        <Typography
          variant="h4"
          fontWeight={700}
          color="text.primary"
          gutterBottom
        >
          Booking Confirmed
        </Typography>

        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          Thank you for your booking. A representative will contact you shortly
          to confirm your information and discuss the details.
        </Typography>

        <Stack
          direction={isMobile ? "column" : "row"}
          spacing={2}
          width="100%"
          justifyContent="center"
        >
          <Button
            variant="outlined"
            onClick={onBack}
            sx={{
              borderRadius: 6,
              px: 4,
              py: 1.5,
              textTransform: "none",
              fontWeight: 600,
            }}
          >
            Back
          </Button>

          <Button
            variant="contained"
            onClick={() => navigate(`/${businessName}/select-service`)}
            sx={{
              borderRadius: 6,
              px: 4,
              py: 1.5,
              textTransform: "none",
              fontWeight: 600,
              backgroundColor: theme.palette.primary.main,
              "&:hover": {
                backgroundColor: theme.palette.primary.dark,
              },
            }}
          >
            Return Home
          </Button>
        </Stack>
      </Box>
    </Container>
  );
};

export default Confirmation;
